<template>
  <div id="usertwo">我是第一个chart</div>
</template>
<script>
export default {
  data(){return{}},
  mounted(){
    this.chartPartFun()
  },
  methods:{
    //画图
    chartPartFun() {
      var chart = echarts.init(document.getElementById("usertwo"));
      var option = {
          top: 25,
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        grid: {
          left: "16px",
          right: "0px",
          top:'25px',
          bottom:'25px',
          containLabel:true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },

        yAxis: {
          type: "value",
          axisLine: {
            show: false
          }
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            symbolSize: 6,
            symbol: "circle", //拐点设置为实心
            itemStyle: {
              normal: {
                color: "#9FE6B8"
              }
            }
          }
        ]
      };

      chart.setOption(option);
      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
  }
}
</script>